import { render, staticRenderFns } from "./oauth-callback.vue?vue&type=template&id=6b9108d8"
import script from "./oauth-callback.vue?vue&type=script&lang=js"
export * from "./oauth-callback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports